import styled from "styled-components"
import { Card } from "reactstrap"

const CardEditStyled = styled(Card)`
    border: 2px solid #4e2d78;
`

export default CardEditStyled